import { Text } from '@mantine/core';
import type { Table } from '@tanstack/react-table';
import { cn } from '~/common/string/classname';

export default function DataTableRowsSelected<TData>({
  table,
  className,
}: {
  table: Table<TData>;
  className?: string;
}) {
  return (
    <Text className={cn('text-xs text-[var(--mantine-color-dimmed)]', className)}>
      <span className="font-medium">{table.getFilteredSelectedRowModel().rows.length}</span> selected
    </Text>
  );
}
